/**
 * @generated SignedSource<<03e376f630e4a48742f45ff72cf17e41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseMyDailyFiveContent$data = {
  readonly paywallTypes?: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hooksUseMyDailyFiveContent";
};
export type hooksUseMyDailyFiveContent$key = {
  readonly " $data"?: hooksUseMyDailyFiveContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseMyDailyFiveContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksUseMyDailyFiveContent",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaywallType",
          "kind": "LinkedField",
          "name": "paywallTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "df0f15bc20e6380fa1792c998bfbfa71";

export default node;
